var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor bot-response" }, [
    _c("div", { staticClass: "palette" }, [
      _c("h4", [_vm._v(_vm._s(_vm.$t("chatbotv2.responses")))]),
      _vm._v(" "),
      _c("div", { staticClass: "items" }, [
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.TEXT)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("text_fields")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.TEXT.type)
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(
                  _vm.Payloads.BOT_RESPONSE.RANDOM_TEXT
                )
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("shuffle")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "chatbotv2." + _vm.Payloads.BOT_RESPONSE.RANDOM_TEXT.type
                  )
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.IMAGE)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("image")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.IMAGE.type)
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.GALLERY)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("auto_awesome_motion")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.GALLERY.type)
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.BUTTON)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("view_carousel")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.BUTTON.type)
                  )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(
                  _vm.Payloads.BOT_RESPONSE.QUICK_REPLY
                )
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("smart_button")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "chatbotv2." + _vm.Payloads.BOT_RESPONSE.QUICK_REPLY.type
                  )
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.FILE)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("attach_file")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.FILE.type)
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(
                  _vm.Payloads.BOT_RESPONSE.AI_RANDOM_TEXT
                )
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("smart_button")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "chatbotv2." + _vm.Payloads.BOT_RESPONSE.AI_RANDOM_TEXT.type
                  )
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.AI_IMAGE)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("image")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.AI_IMAGE.type)
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(
                  _vm.Payloads.BOT_RESPONSE.PRIVATE_MESSAGE
                )
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("disabled_visible")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "chatbotv2." +
                      _vm.Payloads.BOT_RESPONSE.PRIVATE_MESSAGE.type
                  )
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(
                  _vm.Payloads.BOT_RESPONSE.DYNAMIC_BUTTON
                )
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("dynamic_feed")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [_vm._v("Dynamic Button")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(
                  _vm.Payloads.BOT_RESPONSE.DYNAMIC_QUICK_REPLY
                )
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("dynamic_form")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v("Dynamic Quick Reply"),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "payload-wrapper" },
      _vm._l(_vm.payload, function (p, i) {
        return _c(
          "div",
          {
            key: p.id || "payload-" + i,
            staticClass: "payload",
            attrs: { draggable: "true" },
            on: {
              dragstart: function ($event) {
                return _vm.startDrag($event, i)
              },
              drop: function ($event) {
                return _vm.onDrop($event, i)
              },
              dragover: function ($event) {
                $event.preventDefault()
              },
              dragenter: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "actions-wrapper" },
              [
                _c("MessageDelaySlider", {
                  on: { "active-state": _vm.handleActiveState },
                  model: {
                    value: _vm.payload[i].delay,
                    callback: function ($$v) {
                      _vm.$set(_vm.payload[i], "delay", $$v)
                    },
                    expression: "payload[i].delay",
                  },
                }),
                _vm._v(" "),
                _vm.showDelayInput
                  ? _c("MessageDelayInput", {
                      model: {
                        value: _vm.payload[i].delay,
                        callback: function ($$v) {
                          _vm.$set(_vm.payload[i], "delay", $$v)
                        },
                        expression: "payload[i].delay",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$_.get(_vm.payload[i], "filters.items", []).length
                  ? _c("MessageFilterAdder", {
                      attrs: {
                        "on-filter-added": function (filterItem) {
                          return _vm.onFilterAdded(i, filterItem)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.$_.get(_vm.payload[i], "filters.items", []).length > 0
              ? _c("MessageFilterList", {
                  attrs: {
                    "show-remove-button": false,
                    "on-removed": function (id) {
                      return _vm.onFilterRemoved(i, id)
                    },
                    "default-selected-filter-id": _vm.lastAddedFilterId,
                  },
                  model: {
                    value: _vm.payload[i].filters,
                    callback: function ($$v) {
                      _vm.$set(_vm.payload[i], "filters", $$v)
                    },
                    expression: "payload[i].filters",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.previewMode
              ? _c("div", { staticClass: "toolbar" }, [
                  _c(
                    "button",
                    {
                      staticClass: "toolbar-btn",
                      on: {
                        click: function ($event) {
                          return _vm.payload.splice(i, 1)
                        },
                      },
                    },
                    [
                      _c("md-icon", { staticStyle: { color: "#06a9f3" } }, [
                        _vm._v("delete"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "toolbar-btn" },
                    [
                      _c("md-icon", { staticStyle: { color: "#06a9f3" } }, [
                        _vm._v("swap_vert"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "toolbar-btn",
                      on: {
                        click: function ($event) {
                          return _vm.duplicateItem(_vm.payload[i])
                        },
                      },
                    },
                    [
                      _c("md-icon", { staticStyle: { color: "#06a9f3" } }, [
                        _vm._v("content_copy"),
                      ]),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            p.type === _vm.Payloads.BOT_RESPONSE.TEXT.type
              ? _c("TextMessage", {
                  attrs: { "preview-mode": _vm.previewMode },
                  model: {
                    value: p.text,
                    callback: function ($$v) {
                      _vm.$set(p, "text", $$v)
                    },
                    expression: "p.text",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            p.type === _vm.Payloads.BOT_RESPONSE.PRIVATE_MESSAGE.type
              ? _c("PrivateMessage", {
                  attrs: { "preview-mode": _vm.previewMode },
                  model: {
                    value: p.text,
                    callback: function ($$v) {
                      _vm.$set(p, "text", $$v)
                    },
                    expression: "p.text",
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.RANDOM_TEXT.type
              ? _c("RandomTextMessage", {
                  attrs: {
                    "show-attributes": _vm.showAttr === i,
                    texts: p.texts,
                    "on-updated": function (data) {
                      return _vm.updateItem(p, data)
                    },
                    "on-attribute-added": _vm.onAttributeAdded,
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.AI_RANDOM_TEXT.type
              ? _c("AIRandomTextMessage", {
                  attrs: {
                    texts: p.texts,
                    "on-updated": function (data) {
                      return _vm.updateItem(p, data)
                    },
                    "on-attribute-added": _vm.onAttributeAdded,
                    prompt: p.prompt,
                    "preview-mode": _vm.previewMode,
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.GALLERY.type
              ? _c("GalleryMessageEditor", {
                  attrs: {
                    "show-attributes": _vm.showAttr === i,
                    cards: p.cards,
                    "on-updated": function (data) {
                      return _vm.updateItem(p, data)
                    },
                    "on-attribute-added": _vm.onAttributeAdded,
                    "flatted-diagram": _vm.flattedDiagram,
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.IMAGE.type
              ? _c("ImageBotResponse", {
                  attrs: {
                    "default-image-url": p.imageUrl,
                    "default-asset-id": p.assetId,
                    "default-mode": p.mode,
                    "on-updated": function (data) {
                      return _vm.updateItem(p, data)
                    },
                    "whatsapp-mode": false,
                    "allowed-attributes": _vm.allowedAttributes,
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.FILE.type
              ? _c("FileBotResponse", {
                  attrs: {
                    "default-file-url": p.fileUrl,
                    "default-asset-id": p.assetId,
                    "on-updated": function (data) {
                      return _vm.updateItem(p, data)
                    },
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.BUTTON.type
              ? _c("ButtonMessageEditor", {
                  attrs: { flattedDiagram: _vm.flattedDiagram },
                  model: {
                    value: _vm.payload[i],
                    callback: function ($$v) {
                      _vm.$set(_vm.payload, i, $$v)
                    },
                    expression: "payload[i]",
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.QUICK_REPLY.type
              ? _c("QuickReplyMessageEditor", {
                  attrs: { flattedDiagram: _vm.flattedDiagram },
                  model: {
                    value: _vm.payload[i],
                    callback: function ($$v) {
                      _vm.$set(_vm.payload, i, $$v)
                    },
                    expression: "payload[i]",
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.AI_IMAGE.type
              ? _c("AIImage", {
                  attrs: { "preview-mode": _vm.previewMode },
                  model: {
                    value: p.prompt,
                    callback: function ($$v) {
                      _vm.$set(p, "prompt", $$v)
                    },
                    expression: "p.prompt",
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.DYNAMIC_BUTTON.type
              ? _c("DynamicButtonMessageEditor", {
                  attrs: { flattedDiagram: _vm.flattedDiagram },
                  model: {
                    value: _vm.payload[i],
                    callback: function ($$v) {
                      _vm.$set(_vm.payload, i, $$v)
                    },
                    expression: "payload[i]",
                  },
                })
              : p.type === _vm.Payloads.BOT_RESPONSE.DYNAMIC_QUICK_REPLY.type
              ? _c("DynamicQuickReplyMessageEditor", {
                  attrs: { flattedDiagram: _vm.flattedDiagram },
                  model: {
                    value: _vm.payload[i],
                    callback: function ($$v) {
                      _vm.$set(_vm.payload, i, $$v)
                    },
                    expression: "payload[i]",
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }